import * as React from "react";
import { CloseOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, message, Tabs, Table, Radio, Input, Select, Tooltip } from "antd";
const { Option } = Select;
import { inject, observer } from "mobx-react";

import { SessionStore, PriceStore, LocaleStore } from "@/stores";
import { project } from "@/config.json";
import API from "@/apis";

import "./index.less";

import { MachineItem, PowerPrice, MoneyUnit, MoneyFlag, CoinType, EchartSeries } from "@/models";

import _ from "lodash";
import ReactEcharts from "echarts-for-react";
import moment from "moment";
import { LangType } from "@/stores/LocaleStore";
import { CoinHelper } from "@/utils";
import MyIcon from "@/components/MyIcon";
import Mbutton from "@/components/CommonButton";

//电费区间
const feeRatioInterval = [
  [0, 25],
  [25, 50],
  [50, 75],
  [75, Number.POSITIVE_INFINITY],
];
//净利润/T/天
// const dailyNetProfitInterval = [
//   [Number.POSITIVE_INFINITY, 30],
//   [30, 10],
//   [10, 0],
//   [0, Number.NEGATIVE_INFINITY]
// ];
const dailyNetProfitInterval = [
  [Number.POSITIVE_INFINITY, 0.5],
  [0.5, 0.3],
  [0.3, 0],
  [0, Number.NEGATIVE_INFINITY],
];
//净利润样式
const progressClassnames = ["excellent", "good", "normal", "bad"];

// BTC区间
// USD,3000至20000,每200一个点
// 人民币,15000至100000,每1000一个点

// BSV区间
// USD，50至4000， 每20一个点
// 人民币，300至20000,每100一个点
const echartXAxisInterval = {
  [LangType.FA]: {
    [CoinType.BSV]: [50, 4000],
    [CoinType.BTC]: [3000, 2000],
  },
  [LangType.EN]: {
    [CoinType.BSV]: [50, 4000],
    [CoinType.BTC]: [3000, 2000],
  },
  [LangType.ZH]: {
    [CoinType.BSV]: [300, 20000],
    [CoinType.BTC]: [20000, 200000],
  },
};

const echartXAxisStepInterval = {
  EN: {
    [CoinType.BSV]: 20,
    [CoinType.BTC]: 200,
  },
  ZH: {
    [CoinType.BSV]: 100,
    [CoinType.BTC]: 2000,
  },
  FA: {
    [CoinType.BSV]: 100,
    [CoinType.BTC]: 2000,
  },
};

export interface MachineProfitProps {
  session: SessionStore;
  locale: LocaleStore;
  price: PriceStore;
}

export interface MachineProfitState {
  btcDifficulty: number;
  bsvDifficulty: number;
  btcReward: number;
  bsvReward: number;
  btc2cny: number;
  bsv2cny: number;
  btc2usd: number;
  bsv2usd: number;
  machineList: MachineItem[];
  fee: PowerPrice;
  coinType: CoinType;
  selected: number;
  expandedRowKeys: string[];
  machineSelectList: string[];
  machineSelectValues: number[];
  machinePriceList: number[];
  machinePaybackList: number[];
  enumCoinPriceList: number[];
  echartSeries: EchartSeries[];
}

@inject("session", "locale", "price")
@observer
class MachineProfit extends React.Component<MachineProfitProps, MachineProfitState> {
  constructor(props: Readonly<MachineProfitProps>) {
    super(props);
    const { locale } = props;
    this.state = {
      btcDifficulty: 0,
      bsvDifficulty: 0,
      btcReward: 0,
      bsvReward: 0,
      btc2cny: 0,
      bsv2cny: 0,
      btc2usd: 0,
      bsv2usd: 0,
      machineList: [],
      coinType: CoinType.BSV,
      // coinType: CoinType.BTC,
      fee: +localStorage.fee || (locale.isCN ? PowerPrice.cny : PowerPrice.usd),
      selected: -1,
      expandedRowKeys: [],
      machineSelectList: [],
      machineSelectValues: Array(5).fill(0),
      machinePriceList: Array(5).fill(0),
      machinePaybackList: Array(5).fill(0),
      echartSeries: [],
      enumCoinPriceList: [],
    };
  }

  echartRef: any;

  componentDidMount() {
    this.fetchData();
  }

  // state = {} as MachineProfitState;

  fetchData = async () => {
    try {
      const { data } = await API.Open.getDayEarn();
      // console.log(data);

      const { BSV_difficulty, BSV_reward, BTC_difficulty, BTC_reward, cny2btc_bsv } = data.data;

      let btcDifficulty = BTC_difficulty;
      let bsvDifficulty = BSV_difficulty;

      let btcReward = +CoinHelper.amount2bsv(BTC_reward);
      let bsvReward = +CoinHelper.amount2bsv(BSV_reward);

      const { btc2cny, bsv2cny, btc2usd, bsv2usd } = cny2btc_bsv;

      this.setState({
        btcDifficulty,
        bsvDifficulty,
        btcReward,
        bsvReward,
        btc2cny,
        bsv2cny,
        btc2usd,
        bsv2usd,
      });
    } catch (error) {}

    try {
      const { data } = await API.Open.findMachine();
      const newData = data.data.map((item: MachineItem) => ({
        ...item,
        unitPowerConsumption: (+item.powerConsumption / +item.computingPower).toFixed(1),
      }));
      this.setState({
        machineList: newData,
      });
    } catch (error) {}
  };

  handleFeeChange = (e) => {
    const { value } = e.target;
    this.setState(
      {
        fee: +value,
      },
      this.reCalcChart
    );
  };

  reCalcChart = () => {
    const { machinePriceList, machineSelectList } = this.state;
    if (!machineSelectList.length) return;
    machineSelectList.forEach((id, index) => {
      this.handleMachinePriceChange(
        index,
        id
      )({
        target: {
          value: machinePriceList[index],
        },
      });
    });
  };

  handleCheck = (event) => (event.key == "e" ? event.preventDefault() : true);

  get languageKey() {
    const { locale } = this.props;
    return locale.isCN ? "zh" : "en";
  }

  get moneyFlag() {
    const { locale } = this.props;
    return locale.isCN ? MoneyFlag.cny : MoneyFlag.usd;
  }

  get moneyUnit() {
    const { locale } = this.props;
    return locale.isCN ? MoneyUnit.cny : MoneyUnit.usd;
  }

  get datasource() {
    const { machineList, coinType, fee } = this.state;
    const { price } = this.props;
    if (!machineList.length) return [];

    // 拼接bsvDifficulty
    const difficulty = this.state[`${coinType.toLowerCase()}Difficulty`];
    // 拼接bsvReward
    const reward = this.state[`${coinType.toLowerCase()}Reward`];
    // 拼接bsv2cny
    const coinPrice = this.state[`${coinType.toLowerCase()}2${this.moneyUnit}`];
    const list = machineList
      .filter((t) => Number(t.powerConsumption) == +t.powerConsumption)
      .map((item) => {
        const dailyCoinProfit = price.calcDayEarns(+item.computingPower, reward, +difficulty);
        // 每日产出
        const dailyProfit = dailyCoinProfit * coinPrice;
        // 每日电费
        const dailyFee = (fee * +item.powerConsumption * 24) / 1000;
        // 电费占比
        const feeCostRatio = (dailyFee / dailyProfit) * 100;
        // 净利润/天
        const netProfit = dailyProfit - dailyFee;
        // 净利润/天/T
        const dailyNetProfit = (dailyProfit - dailyFee) / +item.computingPower;

        return {
          ...item,
          dailyProfit: +dailyProfit.toFixed(2),
          dailyFee: +dailyFee.toFixed(2),
          feeCostRatio: +feeCostRatio.toFixed(2),
          dailyNetProfit: +dailyNetProfit.toFixed(2),
          netProfit: +netProfit.toFixed(2),
        };
      });

    return list;
  }

  get columns() {
    const { locale } = this.props;
    return [
      {
        //align: "center",
        title: locale.get("machineName"),
        dataIndex: "machineName_zh",
        width: "240px",
        render: (_text, record) => {
          return (
            <div className="memepool-number-table-font" style={{ wordBreak: "break-all" }}>
              <MyIcon
                type="iconxiala"
                className={
                  !this.state.expandedRowKeys.includes(record._id) ? "icon-down" : "icon-up"
                }
                onClick={this.handleExpand(record)}
              />
              {record[`machineName_${this.languageKey}`]}
            </div>
          );
        },
      },
      {
        align: "center",
        title: locale.get("power"),
        dataIndex: "computingPower",
        className: "number-cell",
        render: (text) => (
          <div>
            <span className="memepool-number-table-font mempool-table-data-gutter-right">
              {text}
            </span>
            <span className="memepool-table-unit">T</span>
          </div>
        ),
        sorter: (a, b) => a.computingPower - b.computingPower,
      },
      {
        align: "center",
        title: locale.get("consumption"),
        dataIndex: "powerConsumption",
        className: "number-cell",
        render: (text) => (
          <div>
            <span className="memepool-number-table-font mempool-table-data-gutter-right">
              {text}
            </span>
            <span className="memepool-table-unit">W</span>
          </div>
        ),
        sorter: (a, b) => a.powerConsumption - b.powerConsumption,
      },
      {
        align: "center",
        title: locale.get("Unit power consumption"),
        dataIndex: "unitPowerConsumption",
        className: "number-cell",
        render: (text) => (
          <div>
            <span className="memepool-number-table-font mempool-table-data-gutter-right">
              {text}
            </span>
            <span className="memepool-table-unit">W/T</span>
          </div>
        ),
        sorter: (a, b) => a.unitPowerConsumption - b.unitPowerConsumption,
      },
      {
        align: "center",
        title: locale.get("Daily output"),
        dataIndex: "dailyProfit",
        className: "number-cell",
        render: (text) => (
          <div>
            <span className="memepool-table-unit mempool-table-data-gutter-right">
              {this.moneyFlag}
            </span>
            <span className="memepool-number-table-font">{text}</span>
          </div>
        ),
        sorter: (a, b) => a.dailyProfit - b.dailyProfit,
      },
      {
        align: "center",
        title: locale.get("Daily electricity fee"),
        dataIndex: "dailyFee",
        className: "number-cell",
        render: (text) => (
          <div>
            <span className="memepool-table-unit mempool-table-data-gutter-right">
              {this.moneyFlag}
            </span>
            <span className="memepool-number-table-font">{text}</span>
          </div>
        ),
        sorter: (a, b) => a.dailyFee - b.dailyFee,
      },
      {
        align: "center",
        title: locale.get("Electricity cost ratio"),
        dataIndex: "feeCostRatio",
        // className: "number-cell",
        width: "200px",
        render: (text) => (
          <div className="progress-ratio">
            <div className="real-value memepool-number-table-font">
              <span className="mempool-table-data-gutter-right">{text}</span>%
            </div>
            <div
              className={`real-ratio ${_.get(
                progressClassnames,
                feeRatioInterval.findIndex((item) =>
                  _.inRange(text, item[0], item[item.length - 1])
                )
              )}`}
              style={{ width: `${text > 100 ? 100 : text}%` }}
            ></div>
          </div>
        ),
        sorter: (a, b) => a.feeCostRatio - b.feeCostRatio,
      },
      {
        align: "center",
        title: locale.get("Net profit/T/day"),
        dataIndex: "dailyNetProfit",
        render: (text) => (
          <Mbutton
            onClick={() => {}}
            text={
              <div>
                <span style={{ fontSize: "12px", marginRight: "10px" }}>{this.moneyFlag}</span>
                <span className="memepool-number-font">{text}</span>
              </div>
            }
          ></Mbutton>
          //  <div className="net-profit">
          //    <div
          //     className={`real-ratio ${_.get(
          //       progressClassnames,
          //       dailyNetProfitInterval.findIndex((item) =>
          //         _.inRange(text, item[0], item[item.length - 1])
          //       )
          //     )}`}
          //   >
          //     {this.moneyFlag} {text}
          //   </div>
          //  </div>
        ),
        sorter: (a, b) => a.dailyNetProfit - b.dailyNetProfit,
      },
      // {
      //   align: "center",
      //   title: "",
      //   render: (text, record) => (
      //     <Button
      //       type="primary"
      //       ghost={!this.state.expandedRowKeys.includes(record._id)}
      //       onClick={this.handleExpand(record)}
      //     >
      //       {locale.get("payback period")}
      //     </Button>
      //   ),
      // },
    ] as any;
  }

  handleCoinTypeChange = (value) =>
    this.setState({
      coinType: value,
      expandedRowKeys: [],
      echartSeries: [],
      machineSelectList: [],
      machinePriceList: [],
    });

  handleSetFee = (type) => () => {
    let { fee } = this.state;
    if (type == "-") {
      fee -= 0.01;
    }
    if (type == "+") {
      fee += 0.01;
    }

    if (fee != -Infinity && fee != +Infinity && !isNaN(fee) && fee > 0) {
      this.setState(
        {
          fee: +fee.toFixed(2),
        },
        this.reCalcChart
      );
    }
  };

  handleExpand = (record: MachineItem) => () => {
    this.getEchartOption();
    if (this.state.expandedRowKeys.includes(record._id)) {
      this.setState({
        expandedRowKeys: [],
      });
    } else {
      this.setState(
        {
          expandedRowKeys: [record._id],
          machineSelectList: [record._id],
          machinePriceList: [record[`channelPrice_${this.languageKey}`]],
          echartSeries: [
            {
              data: [],
              type: "line",
              name: record[`machineName_${this.languageKey}`],
            },
          ],
        },
        () =>
          this.handleMachinePriceChange(
            0,
            record._id
          )({
            target: {
              value: record[`channelPrice_${this.languageKey}`],
            },
          })
      );
    }
  };

  getEchartOption = (data?: EchartSeries[]) => {
    const { locale } = this.props;
    const { coinType, echartSeries, enumCoinPriceList } = this.state;
    const option = {
      color: ["#9DBCFB", "#9CE8CA", "#9EA9BE", "#FAD773", "#F1A492"],
      // title: {
      //   text: locale.get("payback period"),
      //   padding: [24, 80],
      //   textStyle: {
      //     color: "#3751FF",
      //     fontSize: 14,
      //     fontWeight: 400,
      //   },
      // },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: echartSeries[name],
      },
      grid: {
        top: 68,
        left: 20,
        right: 60,
        bottom: 0,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: !enumCoinPriceList.length
          ? echartXAxisInterval[locale.getLangType][coinType]
          : enumCoinPriceList,
        interval: echartXAxisStepInterval[locale.getLangType][coinType],
        axisLabel: {
          margin: 20,
          textStyle: {
            color: "#000",
            fontSize: "14",
          },
          formatter: `${this.moneyFlag} {value}`,
        },
        axisLine: {
          lineStyle: {
            color: "#E1E5FE",
          },
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: "value",
        data: [0, 360, 720],
        min: 0,
        max: 720,
        interval: 180,
        axisLine: {
          lineStyle: {
            color: "#ffffff",
          },
        },
        axisLabel: {
          margin: 20,
          textStyle: {
            color: "#000",
            fontSize: "14",
          },
        },
        axisTick: {
          alignWithLabel: true,
        },
        // formatter: (value, index) => {
        //   // 格式化成月/日，只在第一个刻度显示年份
        //   if (value >= 720 || value < 0) {
        //     return 720;
        //   }
        //   return value;
        // }
      },
      // series: data ? echartSeries : data
      series: echartSeries,
    };

    return option;
  };

  handleMachineSelect = (value) => {
    this.setState({
      machineSelectList: this.state.machineSelectList.concat(value),
    });
  };

  handleDeleteMachineItem = (id) => () => {
    const { machineSelectList, echartSeries } = this.state;
    this.setState({
      machineSelectList: machineSelectList.filter((_id) => _id != id),
      echartSeries: echartSeries.filter((d) => d.id != id),
    });
  };

  handleMachinePriceChange = (index, id) => (e) => {
    const { machinePriceList, machinePaybackList, coinType, fee, echartSeries } = this.state;
    const { locale, price } = this.props;
    const machinePrice = +e.target.value;
    machinePriceList[index] = machinePrice;
    const item = this.datasource.find((item) => item._id == id)!;
    const payback = machinePrice / item.netProfit;
    machinePaybackList[index] = Math.round(payback);

    const name = item[`machineName_${this.languageKey}`];
    const type = "line";
    const step = echartXAxisStepInterval[locale.getLangType][coinType];
    const [min, max] = echartXAxisInterval[locale.getLangType][coinType];

    const enumCoinPriceList = _.range(min, max + 1, step);
    const difficulty = this.state[`${coinType.toLowerCase()}Difficulty`];
    const reward = this.state[`${coinType.toLowerCase()}Reward`];

    const dailyCoinProfit = price.calcDayEarns(item.computingPower, reward, difficulty);
    const dailyFee = (fee * +item.powerConsumption * 24) / 1000;

    const data = enumCoinPriceList.map((coinPrice) => {
      const dailyProfit = dailyCoinProfit * coinPrice;
      const netProfit = dailyProfit - dailyFee;
      const payback = Math.ceil(machinePrice / netProfit);
      // return payback;
      return _.inRange(payback, 0, 721) ? payback : 720;
    });

    echartSeries[index] = {
      name,
      type,
      data,
      id,
      // areaStyle: {},
    };

    this.setState(
      {
        machinePriceList,
        machinePaybackList,
        echartSeries,
        enumCoinPriceList,
      },
      this.rerenderChartData
    );
  };

  rerenderChartData = () =>
    this.echartRef && this.echartRef.getEchartsInstance().setOption(this.getEchartOption());

  renderExpandedRowRender = (record) => {
    const {
      expandedRowKeys,
      machineList,
      machineSelectList,
      machinePaybackList,
      machinePriceList,
    } = this.state;
    const { locale } = this.props;
    return (
      expandedRowKeys[0] == record._id && (
        <section className="machine-expanded-row">
          <div className="machine-chart">
            <div className="chart-title">{locale.get("payback period")}</div>
            <ReactEcharts
              ref={(node) => (this.echartRef = node)}
              option={this.getEchartOption()}
              notMerge={true}
              // lazyUpdate={true}
              lazyUpdate={false}
            />
          </div>
          <div className="machine-compare-container">
            <div className="machine-selector">
              <Select
                // mode="tags"
                className="machine-select"
                onChange={this.handleMachineSelect}
                disabled={machineSelectList.length >= 5}
                dropdownMatchSelectWidth={true}
                defaultValue={machineSelectList[0]}
                value={locale.get("login.miner")}
              >
                {machineList.map((item) => (
                  <Option
                    key={item._id}
                    disabled={machineSelectList.includes(item._id)}
                    value={item._id}
                  >
                    {item[`machineName_${this.languageKey}`]}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="machine-select-list">
              {machineSelectList.map((id, index) => {
                const item = machineList.find((one) => one._id == id)!;
                return (
                  <div className="machine-select-item" key={id}>
                    <div className="name">
                      <Tooltip placement="topLeft" title={item[`machineName_${this.languageKey}`]}>
                        <span>{item[`machineName_${this.languageKey}`]}</span>
                      </Tooltip>
                    </div>
                    <div className="input-form">
                      <Input
                        className="fee-form"
                        placeholder={locale.get("login.input")}
                        type="number"
                        value={machinePriceList[index]}
                        onKeyDown={this.handleCheck}
                        onChange={this.handleMachinePriceChange(index, id)}
                        maxLength={6}
                        step={100}
                        min={0}
                        prefix={this.moneyFlag}
                        suffix={`/${locale.get("unit.set")}`}
                      />
                    </div>
                    <div className="payback">
                      {locale.get("fund.Current")} <span>{machinePaybackList[index]}</span>{" "}
                      {locale.get("login.payoff")}
                    </div>
                    <div className="close">
                      {index != 0 ? (
                        <Button
                          type="link"
                          icon={<CloseOutlined />}
                          onClick={this.handleDeleteMachineItem(id)}
                        />
                      ) : (
                        <div style={{ width: "12px" }}></div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )
    );
  };

  render() {
    const { locale } = this.props;
    const { fee, coinType, expandedRowKeys } = this.state;
    const now = moment();
    const minutes = now.minutes();
    return (
      <section className={`machine-profit-container`}>
        {/* <h2>{locale.get("login.rank")}</h2>
        <div className="options">
          <div>
            <Radio.Group
              defaultValue={coinType}
              buttonStyle="solid"
              onChange={this.handleCoinTypeChange}
            >
              <Radio.Button value={CoinType.BSV}>{CoinType.BSV}</Radio.Button>
              <Radio.Button value={CoinType.BTC}>{CoinType.BTC}</Radio.Button>
            </Radio.Group>
            &nbsp; &nbsp;
            <span className="update-time">
              {locale.get("login.update")}{" "}
              {minutes >= 30
                ? now.format("YYYY-MM-DD HH:30:00")
                : now.format("YYYY-MM-DD HH:00:00")}
            </span>
          </div>
          <div className="e-fee">
            <Input
              className="fee-form"
              placeholder={locale.get("login.input")}
              type="number"
              value={fee}
              onKeyDown={this.handleCheck}
              onChange={this.handleFeeChange}
              maxLength={6}
              step={0.01}
              min={0.01}
              prefix={
                <>
                  <MinusCircleOutlined className="icon" onClick={this.handleSetFee("-")} />
                  <span className="desc">&nbsp;{locale.isCN ? `¥` : `$`}&nbsp;</span>
                </>
              }
              suffix={
                <>
                  <span className="desc">&nbsp;/kWh&nbsp;</span>
                  <PlusCircleOutlined className="icon" onClick={this.handleSetFee("+")} />
                </>
              }
            />
          </div>
        </div>
         */}
        <div className="machine-list">
          <div className="machine-top">
            <div>
              <span className="machine-title">{locale.get("login.rank")}</span>
              <span className="update-time">
                {locale.get("login.update")}{" "}
                {minutes >= 30
                  ? now.format("YYYY-MM-DD HH:30:00")
                  : now.format("YYYY-MM-DD HH:00:00")}
              </span>
            </div>
            <div className="e-fee">
              <Input
                className="fee-form"
                placeholder={locale.get("login.input")}
                type="number"
                value={fee}
                onKeyDown={this.handleCheck}
                onChange={this.handleFeeChange}
                maxLength={6}
                step={0.01}
                min={0.01}
                prefix={
                  <>
                    <MinusOutlined className="icon" onClick={this.handleSetFee("-")} />
                    <span className="desc">&nbsp;{locale.isCN ? `¥` : `$`}&nbsp;</span>
                  </>
                }
                suffix={
                  <>
                    <span className="desc">&nbsp;/kWh&nbsp;</span>
                    <PlusOutlined className="icon" onClick={this.handleSetFee("+")} />
                  </>
                }
              />
            </div>
          </div>
          <div className="machine-btn-group">
            <Button
              onClick={() => {
                this.handleCoinTypeChange(CoinType.BSV);
              }}
              style={{
                height: "36px",
                width: "80px",
                background: coinType == CoinType.BSV ? "#2F54EB" : "transparent",
                color: coinType == CoinType.BSV ? "#ffffff" : "#A6A6A6",
                boxShadow: "none",
                border: "none",
              }}
            >
              {CoinType.BSV}
            </Button>
            <Button
              onClick={() => {
                this.handleCoinTypeChange(CoinType.BTC);
              }}
              style={{
                height: "36px",
                width: "80px",
                background: coinType == CoinType.BTC ? "#2F54EB" : "transparent",
                color: coinType == CoinType.BTC ? "#ffffff" : "#A6A6A6",
                boxShadow: "none",
                border: "none",
              }}
            >
              {CoinType.BTC}
            </Button>
          </div>
          <Table
            rowKey={((record) => record._id) as any}
            className="machine-table"
            columns={this.columns}
            dataSource={this.datasource}
            pagination={false}
            expandedRowRender={this.renderExpandedRowRender}
            // expandIconAsCell={false}
            expandIcon={() => null}
            expandIconColumnIndex={-1}
            expandedRowKeys={expandedRowKeys}
          ></Table>
        </div>
      </section>
    );
  }
}

export default MachineProfit as React.ComponentType;
